<div class="top-row">
  <ng-container>
    <div class="button" [attr.showSpinner]="(isTriggering$ | async) || null">
      <sh-button
        [disabled]="(canTrigger$ | async) !== true"
        color="secondary"
        [label]="labels.button"
        [icon]="jobIcon$ | async"
        icon-position="left"
        size="auto"
        (click)="triggerTask()"
      >
      </sh-button>
      <div class="spinner">
        <sh-spinner size="s"></sh-spinner>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isTriggering$ | async; else info">
    <sh-text color="secondary" size="body-1"
      >{{ defaultLabels.triggering }}
    </sh-text>
  </ng-container>
  <ng-template #info>
    <sh-text singletask color="secondary" size="body-1">
      <!-- single task flavor -->
      <ng-container *ngIf="isRunning$ | async; else notRunning">
        Task in progress..
      </ng-container>
      <ng-template #notRunning>
        <i error *ngIf="overallErrorMessage$ | async; let error">
          <b>Error:</b> {{ error }}<br />
        </i>
        {{ labels.lastExecutedLabel }}
        <i *ngIf="lastUpdate$ | async as lastUpdate"
          >{{ lastUpdate | timeFromNow }}.
        </i>
        <i *ngIf="false === !!(lastUpdate$ | async)">
          {{ labels.neverExecuted }}.
        </i>

        <ng-container
          *ngIf="
            (isRunning$ | async) === false &&
            (isTriggering$ | async) === false &&
            false === (canTrigger$ | async)
          "
        >
          <span *ngIf="nextPossibleTrigger$ | async as nextPossibleTrigger"
            >Next request allowed <i>{{ nextPossibleTrigger | timeFromNow }}</i
            >.
          </span>
        </ng-container>
      </ng-template>
    </sh-text>
    <sh-text
      multitask
      *ngIf="lastUpdate$ | async as lastUpdate"
      color="secondary"
      size="body-1"
    >
      <!-- multi task flavor (NOT IMPLEMENTED) -->
      <ng-container *ngIf="isRunning$ | async; else notRunning">
        Task in progress..
      </ng-container>
      <ng-template #notRunning>
        Last successful task execution:
        <i>{{ lastUpdate | timeFromNow }}</i
        >. <br />Next request allowed
        <ng-container
          *ngIf="
            (isRunning$ | async) === false && false === (canTrigger$ | async)
          "
        >
          <i>{{ nextPossibleTrigger$ | async | timeFromNow }}</i
          >.
        </ng-container>
      </ng-template>
    </sh-text>
  </ng-template>
</div>
<div multitask>
  <!-- currently hidden -->
  <ng-container *ngIf="tasks$ | async as steps">
    <div *ngFor="let step of steps" class="row" sh-scale="xs">
      <sh-spinner
        *ngIf="step.taskState === 'Running'"
        indeterminate
        size="s"
      ></sh-spinner>
      <sh-icon
        *ngIf="step.taskState === 'Success'"
        icon="success"
        color="green"
        size="s"
      ></sh-icon>
      <sh-icon
        *ngIf="step.taskState === 'Failure'"
        icon="error"
        size="s"
      ></sh-icon>
      {{ step.label }}
    </div>
  </ng-container>
</div>

<div debug>
  canTrigger$: {{ canTrigger$ | async | json }}<br />
  secondsToNextTrigger$: {{ secondsToNextTrigger$ | async | json }}<br />
  nextPossibleTrigger$: {{ nextPossibleTrigger$ | async | json }}<br />
  lastUpdate$: {{ lastUpdate$ | async | json }}<br />
  isRunning$: {{ isRunning$ | async | json }}<br />
  isInitialized$: {{ isInitialized$ | async | json }}<br />
  isTriggering$: {{ isTriggering$ | async | json }}<br />
</div>
